import { render, staticRenderFns } from "./GalleryPaid.vue?vue&type=template&id=9e6c1c98&"
import script from "./GalleryPaid.vue?vue&type=script&lang=js&"
export * from "./GalleryPaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports